export const company = {
  name: 'Pure Build Construction',
  legalName: 'Pure Build Construction LLC',
  tagline: 'Built Right. Built to Last.',
  phone: '615-864-2014',
  phoneHref: 'tel:+16158642014',
  email: 'Admin@purebuildconstruction.net',
  addressLine1: '130 Chesapeake Trail',
  addressLine2: 'Murfreesboro, TN 37129',
  region: 'Nashville & Middle Tennessee',
  mapsLink:
    'https://www.google.com/maps/place/Pure+Build+Construction/@36.2011378,-87.131031,10z/data=!3m1!4b1!4m6!3m5!1s0x8596a04f56a9dcb:0xca27aa16105ba38b!8m2!3d36.2010356!4d-86.801406!16s%2Fg%2F11njw6hk2f',
  mapsEmbed:
    'https://maps.google.com/maps?q=Pure%20Build%20Construction%20130%20Chesapeake%20Trail%20Murfreesboro%20TN&t=&z=12&ie=UTF8&iwloc=&output=embed',
  logo: 'https://cdn.magicpatterns.com/uploads/ueE9ABqGYPi1wXkHSbwQ4G/image.png',
  hours: 'Mon – Sat · 7:00 AM – 6:00 PM',
}

/** Enhanced photography of the company's own project work. */
export const media = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/4fdde11e-5ce6-4cbd-81ac-a17ec62b24c3.jpg',
  heroOriginal: 'https://cdn.magicpatterns.com/uploads/rTTJvt2iX1R4BvfZy2pxrL/image.png',
  concrete: 'https://cdn.magicpatterns.com/patterns/generated-images/221afc4f-9dd7-4a07-aed5-b280ac2d4e26.jpg',
  concreteOriginal: 'https://cdn.magicpatterns.com/uploads/moXLne3xZjJbRWygC4dLWw/image.png',
  deck: 'https://cdn.magicpatterns.com/patterns/generated-images/5f2bf188-d4ad-452e-be00-bd274c51b910.jpg',
  deckOriginal: 'https://cdn.magicpatterns.com/uploads/wMqSEmweF4bKBiUMTs6P2n/image.png',
  framing: 'https://cdn.magicpatterns.com/patterns/generated-images/df144e30-6ccf-4794-8dde-ef11ef4831c9.jpg',
  framingOriginal: 'https://cdn.magicpatterns.com/uploads/7Fb3Q7heVNdE2gCcdtcFpK/image.png',
  holiday: 'https://cdn.magicpatterns.com/patterns/generated-images/df06c165-8668-4a7f-a750-21daf254c064.jpg',
  holidayOriginal: 'https://cdn.magicpatterns.com/uploads/tskgzWMjnE7x13KtYFKLqH/image.png',
  masonry: 'https://cdn.magicpatterns.com/patterns/generated-images/b751c79e-fd94-4e58-a72b-6183a974adba.jpg',
  remodel: 'https://cdn.magicpatterns.com/patterns/generated-images/a8548034-3169-49c8-8542-3e72eef8aaec.jpg',
  fence: 'https://cdn.magicpatterns.com/patterns/generated-images/fe23c4ec-f248-4416-9a04-67640c45fa30.jpg',
  addition: 'https://cdn.magicpatterns.com/patterns/generated-images/af273d6f-fd69-4e86-8f6e-5d789cc4e77f.jpg',
  crew: 'https://cdn.magicpatterns.com/patterns/generated-images/fdb2ee91-2787-42bc-b17b-6ef6c2eec31c.jpg',
}

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'Why Pure Build', href: '#why' },
  { label: 'Contact', href: '#contact' },
]

export const trustPoints = [
  'Quality Craftsmanship',
  'Reliable Service',
  'Attention to Detail',
  'Built to Last',
]

export type Service = {
  id: string
  index: string
  title: string
  description: string
  image: string
}

export const services: Service[] = [
  {
    id: 'concrete-masonry',
    index: '01',
    title: 'Concrete & Masonry',
    description:
      'Driveways, patios, slabs, foundations, and stonework poured and set to hold their line for decades.',
    image: media.concrete,
  },
  {
    id: 'decks-railings-fences',
    index: '02',
    title: 'Decks, Railings & Fences',
    description:
      'Custom outdoor structures in wood and composite, built square, level, and finished to last through Tennessee seasons.',
    image: media.deck,
  },
  {
    id: 'remodeling',
    index: '03',
    title: 'Remodeling & Renovations',
    description:
      'Kitchens, baths, and full interior renovations that respect the existing home while completely changing how it lives.',
    image: media.remodel,
  },
  {
    id: 'general-construction',
    index: '04',
    title: 'General Construction',
    description:
      'Framing, structural work, build-outs, and additions handled end to end by one accountable crew.',
    image: media.framing,
  },
  {
    id: 'exterior-projects',
    index: '05',
    title: 'Exterior Projects',
    description:
      'Additions, siding, hardscape, and outdoor living spaces that lift curb appeal and add usable square footage.',
    image: media.addition,
  },
  {
    id: 'holiday-lighting',
    index: '06',
    title: 'Holiday Lighting',
    description:
      'Designed, installed, maintained, and removed — professional displays for homes and commercial properties.',
    image: media.holiday,
  },
]

export type ProjectCategory =
  | 'New Construction'
  | 'Renovations'
  | 'Remodeling'
  | 'Exterior'

export type Project = {
  id: string
  name: string
  type: ProjectCategory
  service: string
  location: string
  year: string
  summary: string
  scope: string[]
  image: string
  gallery: string[]
}

export const projects: Project[] = [
  {
    id: 'stonebridge-residence',
    name: 'Stonebridge Residence',
    type: 'New Construction',
    service: 'Custom Home Build',
    location: 'Brentwood, TN',
    year: '2025',
    summary:
      'A ground-up custom residence with stone and stucco exterior, turret entry, and a wide poured driveway — delivered on schedule from footers to final walkthrough.',
    scope: ['Foundation & footers', 'Framing & structure', 'Stone and stucco exterior', 'Driveway & approach'],
    image: media.hero,
    gallery: [media.hero, media.heroOriginal, media.framing],
  },
  {
    id: 'chesapeake-driveway',
    name: 'Chesapeake Drive',
    type: 'Exterior',
    service: 'Concrete & Masonry',
    location: 'Murfreesboro, TN',
    year: '2025',
    summary:
      'Full driveway replacement with a broom finish, control joints cut on a clean grid, and a widened apron for a second vehicle.',
    scope: ['Demolition & haul-off', 'Base prep & grading', 'Poured broom-finish slab', 'Sealed control joints'],
    image: media.concrete,
    gallery: [media.concrete, media.concreteOriginal],
  },
  {
    id: 'harpeth-deck',
    name: 'Harpeth Deck & Railing',
    type: 'Exterior',
    service: 'Decks & Railings',
    location: 'Nashville, TN',
    year: '2025',
    summary:
      'An elevated rear deck with pressure-treated structure and powder-coated black aluminum railing, engineered for entertaining.',
    scope: ['Footings & posts', 'Deck framing', 'Aluminum railing system', 'Stairs & landing'],
    image: media.deck,
    gallery: [media.deck, media.deckOriginal],
  },
  {
    id: 'westview-remodel',
    name: 'Westview Kitchen',
    type: 'Remodeling',
    service: 'Interior Remodel',
    location: 'Franklin, TN',
    year: '2024',
    summary:
      'A dated galley kitchen opened into the living space with a navy island, waterfall quartz, and new oak flooring throughout.',
    scope: ['Wall removal & header', 'Cabinetry & counters', 'Electrical & plumbing', 'Flooring & finishes'],
    image: media.remodel,
    gallery: [media.remodel, media.framing],
  },
  {
    id: 'oakfield-renovation',
    name: 'Oakfield Interior Renovation',
    type: 'Renovations',
    service: 'General Construction',
    location: 'Smyrna, TN',
    year: '2024',
    summary:
      'A full interior gut and re-plan: new stud layout, structural corrections, and a slab prepped for finishes.',
    scope: ['Selective demolition', 'New wall framing', 'Structural corrections', 'Slab prep'],
    image: media.framing,
    gallery: [media.framing, media.framingOriginal],
  },
  {
    id: 'ridgemont-addition',
    name: 'Ridgemont Addition',
    type: 'New Construction',
    service: 'Home Addition',
    location: 'Mt. Juliet, TN',
    year: '2024',
    summary:
      'A two-story addition tied into an existing brick home, matched at the roofline and dried in ahead of schedule.',
    scope: ['Foundation tie-in', 'Two-story framing', 'Sheathing & dry-in', 'Roof integration'],
    image: media.addition,
    gallery: [media.addition, media.framing],
  },
  {
    id: 'brookhaven-hardscape',
    name: 'Brookhaven Hardscape',
    type: 'Exterior',
    service: 'Masonry & Hardscape',
    location: 'Franklin, TN',
    year: '2024',
    summary:
      'Stacked stone retaining walls, a paver patio, and integrated low-voltage lighting turning a slope into usable outdoor living.',
    scope: ['Retaining walls', 'Paver patio', 'Fire feature', 'Landscape lighting'],
    image: media.masonry,
    gallery: [media.masonry],
  },
  {
    id: 'cedar-line-fence',
    name: 'Cedar Line Fence',
    type: 'Exterior',
    service: 'Fencing',
    location: 'La Vergne, TN',
    year: '2024',
    summary:
      'Horizontal cedar privacy fencing with a steel gate frame, set on a dead-straight line across an uneven yard.',
    scope: ['Layout & post setting', 'Horizontal cedar panels', 'Steel gate frame', 'Stain & seal'],
    image: media.fence,
    gallery: [media.fence],
  },
  {
    id: 'north-hills-lighting',
    name: 'North Hills Holiday Display',
    type: 'Renovations',
    service: 'Holiday Lighting',
    location: 'Nashville, TN',
    year: '2025',
    summary:
      'A full roofline and architectural lighting package with warm white runs and color accent uplighting, maintained all season.',
    scope: ['Design consultation', 'Roofline install', 'Accent uplighting', 'Takedown & storage'],
    image: media.holiday,
    gallery: [media.holiday, media.holidayOriginal],
  },
]

export const projectFilters: Array<'All' | ProjectCategory> = [
  'All',
  'New Construction',
  'Renovations',
  'Remodeling',
  'Exterior',
]

export const whyPureBuild = [
  {
    index: '01',
    title: 'Quality First',
    text: 'Every project gets careful attention to materials, workmanship, and detail — no shortcuts hidden behind finishes.',
  },
  {
    index: '02',
    title: 'Built to Last',
    text: 'Construction should stand the test of time. We build to code and then some, because we live in the same towns we work in.',
  },
  {
    index: '03',
    title: 'Clear Communication',
    text: 'You know the plan, the schedule, and the cost. Homeowners stay informed from the first walkthrough to the last.',
  },
  {
    index: '04',
    title: 'Detail-Driven',
    text: 'Straight lines, tight joints, clean edges. The small details are what separate finished work from finished-looking work.',
  },
  {
    index: '05',
    title: 'Reliable Service',
    text: 'We show up when we say we will, protect your property, and leave the site clean at the end of every day.',
  },
  {
    index: '06',
    title: 'Customer Focused',
    text: 'The goal is not simply to finish a project — it is to hand over something you are genuinely proud of.',
  },
]

export const processSteps = [
  {
    index: '01',
    title: 'Consultation',
    text: 'We walk the site, listen to your goals and ideas, and talk honestly about what the project involves.',
  },
  {
    index: '02',
    title: 'Planning',
    text: 'Scope, materials, timeline, and an itemized estimate — everything agreed in writing before work begins.',
  },
  {
    index: '03',
    title: 'Build',
    text: 'Our crew executes with attention to quality and detail, keeping you updated at every meaningful milestone.',
  },
  {
    index: '04',
    title: 'Deliver',
    text: 'Final clean-up, a walkthrough together, and a punch list closed out before we call the job complete.',
  },
]

/** PLACEHOLDER CONTENT — replace with verified customer reviews before launch. */
export const testimonials = [
  {
    quote:
      'The crew treated our property like it was their own. Clear pricing, clear schedule, and the finished work speaks for itself.',
    name: 'Homeowner Name',
    project: 'Concrete Driveway · Murfreesboro',
  },
  {
    quote:
      'They handled a project other contractors would not take on, finished when they said they would, and the detail work is excellent.',
    name: 'Homeowner Name',
    project: 'Deck & Railing · Nashville',
  },
  {
    quote:
      'Communication was the difference. We always knew what was happening next and never had to chase anyone down for an answer.',
    name: 'Homeowner Name',
    project: 'Interior Remodel · Franklin',
  },
]

export const serviceAreas = [
  'Nashville',
  'Murfreesboro',
  'Smyrna',
  'Franklin',
  'Brentwood',
  'La Vergne',
  'Antioch',
  'Mt. Juliet',
]

export const projectTypes = [
  'New Construction',
  'Remodeling & Renovation',
  'Concrete & Masonry',
  'Deck, Railing or Fence',
  'Home Addition',
  'Holiday Lighting',
  'Something Else',
]

export const budgetRanges = [
  'Under $5,000',
  '$5,000 – $15,000',
  '$15,000 – $50,000',
  '$50,000 – $150,000',
  '$150,000+',
  'Not sure yet',
]
